export type User = {
  id: number;
  email: string;
  enabled: boolean;
  roles: RoleEnum[];
  workspaces: string[];
  google_id: string;
  lastname: string;
  firstname: string;
  last_login: string;
  created_at: string;
  updated_at: string;
};

export enum RoleEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export const RoleValues = Object.values(RoleEnum);

export const RoleTranslations = {
  [RoleEnum.ROLE_ADMIN]: {
    label: 'pages.global.user.values.role.admin.label',
    description: 'pages.global.user.values.role.admin.description',
  },
  [RoleEnum.ROLE_USER]: {
    label: 'pages.global.user.values.role.user.label',
    description: 'pages.global.user.values.role.user.description',
  },
};
